import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes,Route, Link } from 'react-router-dom';
import'bootstrap/dist/css/bootstrap.min.css'
import AddProducts from './Components/AddProducts';
import GetProducts from './Components/GetProducts';
import Signin from './Components/Signin';
import Signup from './Components/Signup';
import Payment from './Components/Payment';
import NotFound from './Components/NotFound';




function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <header className="App-header">
          <h1>SOKO GARDEN BUY AND SALE ONLINE</h1>
        </header>
        <nav>
          <Link to="/signup" className="link">
            Signup
          </Link>
          <Link to="/signin" className="link">
            Signin
          </Link>
          <Link to="/addproduct" className="link">
            AddProduct
          </Link>
          <Link to="/getproduct" className="link">
            GetProduct
          </Link>
          <Link to="/payment" className="link">
            Payment
          </Link>
        </nav>
        <Routes>
          <Route path="/signup" element={<Signup />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/addproduct" element={<AddProducts />} />
          <Route path="/getproduct" element={<GetProducts />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/*" element={<NotFound />} />
          <Route path="/" element={<GetProducts />} />
        </Routes>
      </BrowserRouter>
      <footer>
        <div className="row">
          <div className="col-md-5 contact">
            <h2>Contact Us</h2>
            <p>
              <b>Phone: 0792342944</b>
            </p>
            <p>
              <b>Whatsapp: 0792342944</b>
            </p>
            <p>
              <b>Email : ndubipius96@gmail.com</b>
            </p>
            <br />
            <h1>Working Hours</h1>
            Monday to Friday : 8am -7.30pm <br />
            Saturday : 9am -6pm <br />
            Sundays : CLOSED
          </div>
          <div className="col-md-5">
            <form action="">
              <input
                type="text"
                className="form-control"
                placeholder="Enter UserName"
              />
              <br />
              <input type="email" className='form-control' placeholder="Enter Email" /> <br />
              <textarea name="" className='form-control' placeholder='Leave a Message' id=""></textarea>
            </form>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
